import { VStack, HStack, Text, Flex, SkeletonText } from "@reverb-ui/react";
import { Globe, Chat } from "@reverb-ui/icons-react";
import { countries } from "country-data";

export type TTopLocationsProps = {
  isLoading: boolean;
  topGeolocations: {
    country: string;
    percentage: string;
  }[];
};

export const TopLocations = ({
  topGeolocations,
  isLoading,
}: TTopLocationsProps) => (
  <VStack
    id="top-locations"
    alignItems="start"
    justifyContent="space-between"
    spacing={4}
    px={4}
    py={4}
    bg="white"
    borderRadius="4px"
    h="full"
  >
    <VStack alignItems="start" spacing={4} w="full">
      <HStack alignItems="center">
        <Globe size="sm" color="gray.500" />
        <Text color="gray.500" fontWeight="semibold" fontSize="xs">
          LOCATION
        </Text>
      </HStack>
      <Flex w="full" justifyContent="space-between">
        <Text color="gray.500" fontWeight="semibold" fontSize="xs">
          COUNTRY
        </Text>
        <Text color="gray.500" fontWeight="semibold" fontSize="xs">
          TRAFFIC RATE
        </Text>
      </Flex>

      {topGeolocations.map((item, index) => (
        <Flex w="full" justifyContent="space-between" key={index}>
          <SkeletonText
            isLoaded={!isLoading}
            variant="rect"
            noOfLines={1}
            skeletonHeight="1rem"
          >
            <Text color="gray.700" fontSize="sm">
              {countries[item.country]?.name || item.country}
            </Text>
          </SkeletonText>
          <SkeletonText
            isLoaded={!isLoading}
            variant="rect"
            noOfLines={1}
            skeletonHeight="1rem"
          >
            <Text color="gray.700" fontWeight="semibold" fontSize="sm">
              {item.percentage}
            </Text>
          </SkeletonText>
        </Flex>
      ))}
    </VStack>
    {topGeolocations.length < 5 && (
      <HStack w="full" bg="gray.100" p={3}>
        <Chat color="gray.400" />
        <Text fontSize="xs" color="gray.700">
          There aren't 5 sources to show yet.
        </Text>
      </HStack>
    )}
  </VStack>
);
